module.exports = __webpack_public_path__ + "static/media/icon-emergency.40db9503.png";